import React from 'react';
import { Section } from './ui/Section';
export function SceneSection() {
  return <Section background="white" data-id="element-167">
      <div className="prose prose-lg prose-slate mx-auto" data-id="element-168">
        <h2 className="text-3xl font-serif font-bold text-slate-900 mb-6" data-id="element-169">
          Hay un tipo de cansancio que no se arregla con “échale ganas”.
        </h2>

        <p data-id="element-170">
          Es ese cansancio donde cumples, trabajas, atiendes, resuelves… pero
          por dentro estás en modo supervivencia.
        </p>

        <p data-id="element-171">
          Y luego llega la noche. Te acuestas con esperanza, pensando:{' '}
          <em data-id="element-172">“hoy sí”</em>.
        </p>

        <div className="my-8 p-6 bg-slate-50 border-l-4 border-indigo-500 rounded-r-lg" data-id="element-173">
          <p className="font-medium text-slate-900 mb-2" data-id="element-174">Y a las 3am:</p>
          <ul className="list-disc pl-5 space-y-1 text-slate-700" data-id="element-175">
            <li data-id="element-176">calor</li>
            <li data-id="element-177">incomodidad</li>
            <li data-id="element-178">mente encendida</li>
            <li data-id="element-179">
              y ese pensamiento que se siente como sentencia:{' '}
              <strong data-id="element-180">“¿Y si ya no vuelvo a dormir?”</strong>
            </li>
          </ul>
        </div>

        <p className="text-xl font-medium text-slate-900 text-center mt-8" data-id="element-181">
          No necesitas otro tip. Necesitas un plan para ese momento exacto.
        </p>
      </div>
    </Section>;
}